/**
 * AudioVisualizer - Animated bars showing voice activity
 */

import { motion } from 'framer-motion'
import React from 'react'

interface AudioVisualizerProps {
  isActive: boolean
  level?: number
  barCount?: number
  className?: string
  color?: string
  agentState?: string
  audioTrack?: any
  size?: 'small' | 'medium' | 'large'
}

export const AudioVisualizer: React.FC<AudioVisualizerProps> = ({ isActive, barCount = 5, className = '', color = '#10b981', size = 'medium' }) => {
  // Size configurations
  const sizeConfig = {
    small: { barWidth: 'tw-w-3', gap: 'tw-gap-1.5', minHeight: 16, maxHeights: [16, 32, 24, 36, 16] },
    medium: { barWidth: 'tw-w-6', gap: 'tw-gap-3', minHeight: 24, maxHeights: [24, 48, 32, 56, 24] },
    large: { barWidth: 'tw-w-8', gap: 'tw-gap-4', minHeight: 32, maxHeights: [32, 64, 48, 72, 32] },
  }

  const config = sizeConfig[size]

  // Get max height for container
  const maxHeight = Math.max(...config.maxHeights)

  return (
    <div className={`tw-flex tw-items-center tw-justify-center ${config.gap} ${className}`} style={{ height: `${maxHeight}px` }}>
      {[...Array(barCount)].map((_, i) => (
        <motion.div
          key={i}
          animate={{
            height: isActive ? config.maxHeights : config.minHeight,
            opacity: isActive ? [1, 0.8, 1, 0.9, 1] : 0.3,
          }}
          transition={{
            duration: 1.2,
            repeat: Infinity,
            delay: i * 0.15,
            ease: 'easeInOut',
          }}
          className={`${config.barWidth} tw-rounded-full`}
          style={{ backgroundColor: isActive ? color : '#e2e2df', minHeight: `${config.minHeight}px` }}
        />
      ))}
    </div>
  )
}

export default AudioVisualizer
